import React, { Component } from 'react';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from 'modules/admin';
import { browserHistory } from 'react-router';
import { getLocale } from '../intl/helpers';

import { DropdownButton, MenuItem } from 'react-bootstrap';


class SelectPricing extends Component {
    constructor(props) {
        super(props);

        this.state = { subscription: props.value || 'free' }
    }

    render() {
        return <DropdownButton id="select-pricing" bsSize="small" className="btn-select" title={this.state.subscription}>
         <MenuItem onSelect={() => {
                this.setState({ subscription: 'suspended' })
                this.props.onChange('suspended');
            }} eventKey="suspended" active={this.state.subscription === 'suspended'}>suspended</MenuItem>

            <MenuItem onSelect={() => {
                this.setState({ subscription: 'free' })
                this.props.onChange('free');
            }} eventKey="free" active={this.state.subscription === 'free'}>free</MenuItem>
           
           <MenuItem onSelect={() => {
                this.setState({ subscription: 'starter' })
                this.props.onChange('starter');
            }} eventKey="starter" active={this.state.subscription === 'starter'}>starter</MenuItem> 

            <MenuItem onSelect={() => {
                this.setState({ subscription: 'professional' })
                this.props.onChange('professional');
            }} eventKey="professional" active={this.state.subscription === 'professional'}>professional</MenuItem>


        </DropdownButton>
    }
}


class DateFormatter extends React.Component {
  render() {
    let date =  new Date(this.props.date);
      return (<div>
          {this.props.date ? date.toLocaleDateString() + " " + date.toLocaleTimeString() : "-"}
      </div>
      );
  }
}


class Administrator extends Component {

  constructor(props){
    super(props);
    this.state = {
      page: 1,
      limit: 50,
      sortField: 'lastUpdated',
      sortOrder: 'desc',
      search: ''
    };
    this.searchTimeout = null;
  }

  componentDidMount() {
    this.loadUsers();
    this.props.dispatch(actions.fetchGlobalSettings());
  }

  loadUsers() {
    let { dispatch } = this.props;
    const { page, limit, sortField, sortOrder, search } = this.state;
    dispatch(actions.fetchUsers({ page, limit, sortField, sortOrder, search }));
  }

  getParams() {
    const { page, limit, sortField, sortOrder, search } = this.state;
    return { page, limit, sortField, sortOrder, search };
  }

  onDeleteUser(user){
    let {dispatch} = this.props;
    let c = confirm("Are you really really sure?");
    if (c == true) {
      dispatch(actions.deleteUser(user.shopify.shopName, this.getParams()));
    }
  }

  changeSubsription(user, newSubscription){
    let {dispatch} = this.props;
    dispatch(actions.updateSubscription(user._id, newSubscription, this.getParams()));
  }

  onGlobalSwitch(e){
    let {dispatch} = this.props;
    dispatch(actions.updateGlobalSettings(e.target.checked));
  }

  onTokenMode(user, tokenMode){
    let {dispatch} = this.props;
    dispatch(actions.setUserTokenMode(user._id, tokenMode, this.getParams()));
  }

  handlePageChange(newPage) {
    this.setState({ page: newPage }, () => this.loadUsers());
  }

  handleSort(field) {
    this.setState((prev) => ({
      sortField: field,
      sortOrder: prev.sortField === field && prev.sortOrder === 'desc' ? 'asc' : 'desc',
      page: 1
    }), () => this.loadUsers());
  }

  handleSearch(e) {
    const val = e.target.value;
    this.setState({ search: val });
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.setState({ page: 1 }, () => this.loadUsers());
    }, 400);
  }

  render() {
    let { usersTotal = 0, usersPage = 1, usersTotalPages = 1, fetching, expiringEnabled = false, globalError } = this.props;
    let users = Array.isArray(this.props.users) ? this.props.users : [];
    const { sortField, sortOrder, search } = this.state;

    const sortIcon = (field) => {
      if (sortField !== field) return <i className="fa fa-sort" style={{opacity:0.3, marginLeft:4}} />;
      return <i className={`fa fa-sort-${sortOrder === 'asc' ? 'asc' : 'desc'}`} style={{marginLeft:4}} />;
    };

    const tokenCell = (user) => {
      const ts = user.tokenStatus || { tokenMode: 'legacy', needsReconnect: false };
      if (ts.needsReconnect || ts.migrationStatus === 'reconnect-needed') {
        return <div>
          <span style={{color:'#b45309', fontSize:11}}>Reconnect needed</span>
          <div><button className="btn btn-sm btn-primary" onClick={() => this.onTokenMode(user, 'expiring')} disabled={!expiringEnabled}>Re-migrate</button></div>
        </div>;
      }
      return <div>
        <span style={{fontSize:11, color: ts.tokenMode === 'expiring' ? '#047857' : '#475569'}}>
          {ts.tokenMode === 'expiring' ? 'Expiring' : 'Legacy'}
        </span>
        <div>
          <button
            className="btn btn-sm btn-warning"
            disabled={expiringEnabled === false}
            onClick={() => this.onTokenMode(user, ts.tokenMode === 'expiring' ? 'legacy' : 'expiring')}
          >
            {ts.tokenMode === 'expiring' ? 'Disable' : 'Enable'}
          </button>
        </div>
      </div>;
    };

    return (
      <div>
        <style>
          {`
          .btn-sm { padding: 2px 5px !important; }
          .admin-table { width: 100%; border-collapse: collapse; font-size: 13px; }
          .admin-table th { padding: 8px 10px; text-align: left; background: #f8fafc; border-bottom: 2px solid #e2e8f0; cursor: pointer; white-space: nowrap; font-weight: 600; font-size: 12px; color: #475569; }
          .admin-table th:hover { background: #f1f5f9; }
          .admin-table td { padding: 7px 10px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; }
          .admin-table tr:hover td { background: #f8fafc; }
          .admin-pagination { display: flex; align-items: center; gap: 8px; margin-top: 16px; justify-content: space-between; }
          .admin-pagination button { padding: 5px 12px; border: 1px solid #e2e8f0; border-radius: 4px; background: white; cursor: pointer; font-size: 12px; }
          .admin-pagination button:disabled { opacity: 0.4; cursor: not-allowed; }
          .admin-pagination button:hover:not(:disabled) { background: #f1f5f9; }
          .admin-search { padding: 7px 12px; border: 1px solid #e2e8f0; border-radius: 4px; font-size: 13px; width: 260px; margin-bottom: 12px; }
          `}
        </style>
        <Grid fluid>
          <div className="sidebar">
            <Col md={12}>
              <span><i onClick={()=>{browserHistory.push('/' + getLocale() + '/dashboard')}} className="back-button fa fa-arrow-circle-left">&nbsp;</i>Accounts ({usersTotal || 0})</span>
            </Col>
          </div>
          <Row>
            <Col md={12}>
              <div style={{marginBottom:12, display:'flex', alignItems:'center', gap:12, flexWrap:'wrap'}}>
                <label style={{fontSize:13, fontWeight:600, display:'flex', alignItems:'center', gap:6, cursor:'pointer'}}>
                  <input type="checkbox" checked={expiringEnabled} onChange={this.onGlobalSwitch.bind(this)} />
                  Global: expiring offline tokens
                </label>
                <span style={{fontSize:11, color:'#64748b'}}>
                  {expiringEnabled ? 'ON — new acquisitions use expiring tokens' : 'OFF — all stores on legacy tokens'}
                </span>
                {globalError && <span style={{fontSize:11, color:'#b91c1c'}}>{globalError}</span>}
              </div>
              <input
                className="admin-search"
                type="text"
                placeholder="Search by name, email, or shop..."
                value={search}
                onChange={this.handleSearch.bind(this)}
              />
              {fetching && <span style={{marginLeft:12, color:'#64748b', fontSize:12}}>Loading...</span>}
              <table className="admin-table">
                <thead>
                  <tr>
                    <th onClick={() => this.handleSort('dateCreated')}>Date Created {sortIcon('dateCreated')}</th>
                    <th onClick={() => this.handleSort('lastUpdated')}>Last Updated {sortIcon('lastUpdated')}</th>
                    <th onClick={() => this.handleSort('profile.name')}>Name {sortIcon('profile.name')}</th>
                    <th>Shopify Shop</th>
                    <th onClick={() => this.handleSort('generated')}>Invoice # {sortIcon('generated')}</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th onClick={() => this.handleSort('profile.subscription')}>Subscription {sortIcon('profile.subscription')}</th>
                    <th>Tokens</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user) => (
                    <tr key={user._id}>
                      <td><DateFormatter date={user.dateCreated} /></td>
                      <td><DateFormatter date={user.lastUpdated} /></td>
                      <td>{user.name}</td>
                      <td>{user.shopify ? <a href={`https://${user.shopify.shopName}.myshopify.com`} target="_blank">{user.shopify.shopName}</a> : ''}</td>
                      <td>{user.generated}</td>
                      <td><a href={`mailto:${user.email}`}>{user.email}</a></td>
                      <td>{user.phone}</td>
                      <td><SelectPricing value={user.subscription} onChange={this.changeSubsription.bind(this, user)} /></td>
                      <td>{tokenCell(user)}</td>
                      <td><button className="btn btn-sm btn-danger" onClick={this.onDeleteUser.bind(this, user)}><i className="fa fa-minus-circle"/>{' '}Erase</button></td>
                    </tr>
                  ))}
                  {!fetching && users.length === 0 && (
                    <tr><td colSpan="10" style={{textAlign:'center', padding:20, color:'#94a3b8'}}>No users found</td></tr>
                  )}
                </tbody>
              </table>
              <div className="admin-pagination">
                <span style={{fontSize:12, color:'#64748b'}}>
                  Page {usersPage} of {usersTotalPages} ({usersTotal} total)
                </span>
                <div style={{display:'flex', gap:4}}>
                  <button disabled={usersPage <= 1} onClick={() => this.handlePageChange(1)}>First</button>
                  <button disabled={usersPage <= 1} onClick={() => this.handlePageChange(usersPage - 1)}>Prev</button>
                  <button disabled={usersPage >= usersTotalPages} onClick={() => this.handlePageChange(usersPage + 1)}>Next</button>
                  <button disabled={usersPage >= usersTotalPages} onClick={() => this.handlePageChange(usersTotalPages)}>Last</button>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>);
  }

}


Administrator.propTypes = {
  dispatch: PropTypes.func.isRequired,
  websites: PropTypes.array.isRequired,
  users: PropTypes.array.isRequired
}


function mapStateToProps(state) {
  return {
    websites: state.admin.list,
    users: state.admin.users,
    usersTotal: state.admin.usersTotal,
    usersPage: state.admin.usersPage,
    usersTotalPages: state.admin.usersTotalPages,
    fetching: state.admin.fetching,
    expiringEnabled: state.admin.expiringEnabled,
    globalError: state.admin.globalError
  };
}

export default connect(mapStateToProps)(Administrator);



// WEBPACK FOOTER //
// app/containers/Administrator.jsx